import { Component } from "react";
import PropTypes from "prop-types";
import Collapse, { Panel } from "app/components/ui/collapse/Collapse";
import "./MoreDetails.scss";
import { connect } from "react-redux";
import Button, { BUTTON_VARIANTS } from "app/pages/.shared/form/Button";
import classNames from "classnames";

class MoreDetails extends Component {
	constructor(props) {
		super(props);
		this.state = {
			expanded: props.initialExpanded || props.expanded || false,
		};
		this.onChange = this.onChange.bind(this);
	}

	onChange(event) {
		if (typeof event.preventDefault === "function") {
			event.preventDefault();
		}
		const isExpanded = this.state.expanded;
		this.setState({
			expanded: !isExpanded,
		});

		if (typeof this.props.onChange === "function") {
			this.props.onChange(!isExpanded);
		}
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.expanded !== undefined) {
			this.setState({
				expanded: nextProps.expanded,
			});
		}
	}

	render() {
		const {
			children,
			collapsedLabel,
			expandedLabel,
			expandedIcon,
			collapsedIcon,
			headerPosition = "top",
			isPrintMode,
		} = this.props;

		const activeKey = this.state.expanded || isPrintMode ? "0" : undefined;
		const headerNode = this.state.expanded || isPrintMode ? expandedLabel : collapsedLabel;
		const hasIcon = expandedIcon || collapsedIcon;

		const topHeaderNode = headerPosition === "top" ? headerNode : false;

		const bottomHeaderNode = headerPosition === "bottom" && (
			<Button
				variant={BUTTON_VARIANTS.BORDERLESS}
				className="rc-collapse-header"
				onClick={this.onChange}
			>
				{headerNode}
			</Button>
		);

		return (
			<div
				className={classNames("more-details", {
					"more-details--has-icon": hasIcon,
				})}
				data-testid={this.props["data-testid"]}
			>
				<Collapse onChange={this.onChange} activeKey={activeKey}>
					<Panel
						header={
							<Button
								{...(hasIcon && {
									icon: this.state.expanded ? expandedIcon : collapsedIcon,
								})}
								variant={BUTTON_VARIANTS.BORDERLESS}
								label={topHeaderNode}
							/>
						}
					>
						{children}
					</Panel>
				</Collapse>
				{bottomHeaderNode}
			</div>
		);
	}
}

MoreDetails.propTypes = {
	expanded: PropTypes.bool,
	initialExpanded: PropTypes.bool,
	isPrintMode: PropTypes.bool,
	collapsedLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	expandedLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	headerPosition: PropTypes.oneOf(["top", "bottom"]),
	expandedIcon: PropTypes.element,
	collapsedIcon: PropTypes.element,
	onChange: PropTypes.func,
	"data-testid": PropTypes.string,
};

const mapStateToProps = state => {
	return {
		isPrintMode: state.print.isPrintMode,
	};
};

export default connect(mapStateToProps)(MoreDetails);
